module.exports = __webpack_public_path__ + "img/4a6d2b285e8b3e283c493c28beb058d9.4a6d2b28.png";